import { Progress } from "antd";
import React from "react";

function PathwayProgress() {
  return (
    <div className="w-full flex items-start flex-col">
      <div className="text-[#1A1A1A] font-sora text-[1.25rem] font-[600] leading-[1.5rem]">
        Pathway Progress
      </div>

      <div className="mt-[1.25rem] w-full bg-[#F1F3F5] rounded-[1rem] py-[1.5rem] px-[2rem]">
        <div className="flex flex-col items-center justify-center">
          <div className="text-[#1A1A1A] text-[.875rem] font-sora font-[400]">
            Your investment supports
          </div>
          <div className="mt-[1rem] text-[#0092CC] font-sora text-[1.5rem] font-[600] ">
            0.10%
          </div>
          <div className="mt-[1rem] text-[#1A1A1A] font-sora text-[.875rem] font-[400] ">
            of the total Expanded FLID pathway target
          </div>
        </div>

        <div className="mt-[2.25rem]">
          <div className="text-[#424242] font-[400] text-[.875rem] font-sora leading-[1.5rem]">
            Pathway Progress Impact
          </div>
          <Progress percent={30} fill="#0092CC" />
        </div>
      </div>
    </div>
  );
}

export default PathwayProgress;
